<template>
    <!-- theme one -->
    <div v-if="themeStore.themeIndex == 1">
        <ActiveBonusView :data-set="dataSet" @activeBonusClaim="activeBonusClaim" />
    </div>
    <div v-if="themeStore.themeIndex == 2">
        <ActiveBonusViewTwo :data-set="dataSet" @activeBonusClaim="activeBonusClaim" />
    </div>
    <LoadingScreen ref="loadingRef" />
    <StatusPopup ref="statusRef" :is-show-success="isSuccess" :content="toastContent" />
</template>
<script setup lang="ts">
import LoadingScreen from '@/components/common/loadingScreen.vue';
import { onMounted, ref } from 'vue';
import StatusPopup from '@/components/common/statusPopup.vue';
import { activeBonuseClaim, getActiveBonusInfo } from '@/api/activity';
import { useUserStore } from '@/stores/user';
import ActiveBonusView from '@/themes/themeOne/activeBonus/activeBonusView.vue';
import { ActiveBonusData } from './supportScript';
import ActiveBonusViewTwo from '@/themes/themeTwo/activeBonus/activeBonusView.vue';
import { useThemeStore } from '@/stores/theme';

const themeStore = useThemeStore()
const userStore = useUserStore()
const loadingRef = ref()
const isSuccess = ref(false)
const toastContent = ref('')
const statusRef = ref()
const yesterRewardAmount = ref(0)
const todayRewardAmount = ref(0)
const yesterBetAmount = ref(0)
const todayBetAmount = ref(0)
const activityIntro = ref([])
const activityConfig = ref<any>({})
const rewardList = ref([])
const flatIcon = ref('')

const dataSet = ref<ActiveBonusData>({
    yesterRewardAmount: 0,
    todayRewardAmount: 0,
    yesterBetAmount: 0,
    todayBetAmount: 0,
    activityIntro: [],
    activityConfig: {},
    rewardList: [],
    flatIcon: ''
})
const showError = (message: string) => {
    toastContent.value = message;
    isSuccess.value = false;
    statusRef.value.open()
}
const showSuccess = (message: string) => {
    toastContent.value = message;
    isSuccess.value = true;
    statusRef.value.open()
}
const getActivityInfo = () => {
    loadingRef.value.open()
    getActiveBonusInfo().then(res => {
        loadingRef.value.close()
        activityConfig.value = res.data
        yesterBetAmount.value = res.data?.yesterdayBet || 0
        yesterRewardAmount.value = res.data?.yesterdayCoin || 0
        todayBetAmount.value = res.data?.todayBet || 0
        todayRewardAmount.value = res.data?.todayCoin || 0
        activityConfig.value = JSON.parse(res.data?.activityVo?.activityConfig) || {}
        rewardList.value = activityConfig.value?.rewards || []
        activityIntro.value = JSON.parse(res.data?.activityVo?.activityIntro) || []
        flatIcon.value = res.data?.activityVo?.flatIcon || ''

        dataSet.value = {
            activityConfig: activityConfig.value,
            yesterBetAmount: yesterBetAmount.value,
            yesterRewardAmount: yesterRewardAmount.value,
            todayBetAmount: todayBetAmount.value,
            todayRewardAmount: todayRewardAmount.value,
            rewardList: rewardList.value,
            activityIntro: activityIntro.value,
            flatIcon: flatIcon.value
        }
    }).catch(err => {
        if (err.code != 401) {
            loadingRef.value.close();
            showError(err);
        }
    })
}

const activeBonusClaim = () => {
    loadingRef.value.open()
    let data = {
        uid: userStore.id
    }
    activeBonuseClaim(data).then(res => {
        loadingRef.value.close()
        getActivityInfo()
    }).catch(err => {
        if (err.code != 401) {
            loadingRef.value.close();
            showError(err);
        }
    })
}
onMounted(() => {
    getActivityInfo();
})
</script>
